import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { BILLING_ROLE, homeRouteFor, RENEWAL_ROLE } from '@/utils/constants';

// Guards the Billing workspace. Assumes it is nested inside ProtectedRoute, so
// the user is already authenticated; here we only check the Billing jobRole
// (admins may also view it for support/oversight).
const BillingRoute = () => {
  const user = useAppSelector((state) => state.auth.user);
  const allowed =
    user?.jobRole === BILLING_ROLE || user?.jobRole === RENEWAL_ROLE || user?.role === 'admin';

  if (!allowed) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return <Outlet />;
};

export default BillingRoute;
